import dayjs from 'dayjs';

// A wrapper around dayjs that returns undefined if the datetime string is undefined
// This is needed as dayjs treats dayjs(undefined) as dayjs(), which returns a Day.js object with the current date and time
export const stringToDayJs = (date: string | undefined): dayjs.Dayjs => {
    if (!date) {
        return undefined;
    }

    return dayjs(date);
};
